import MuiSearchBar from './MuiSearchBar';

export default MuiSearchBar;
